import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from './reducer';

export type Dispatch = typeof store.dispatch;

export const store = configureStore({
    reducer: rootReducer,
    // @ts-ignore
    preloadedState: window.__PRELOADED_STATE__,
});

export type RootState = ReturnType<typeof store.getState>;
